import React from "react";
import { spring, useCurrentFrame, useVideoConfig } from "remotion";

export interface StaggerTextProps {
  text: string;
  stagger?: number; // frame gap between words, default 3
  startDelay?: number;
  highlightWords?: string[];
  highlightColor?: string;
  style?: React.CSSProperties;
}

/**
 * Word-by-word cinematic text stagger from Remotion Pro
 */
export const StaggerText: React.FC<StaggerTextProps> = ({
  text,
  stagger = 3,
  startDelay = 0,
  highlightWords = [],
  highlightColor = "#5D3FD3",
  style,
}) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  const words = text.split(" ");

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "center",
        gap: "0 0.28em",
        ...style,
      }}
    >
      {words.map((word, i) => {
        const p = spring({
          frame,
          fps,
          delay: startDelay + i * stagger,
          config: { damping: 200 },
        });

        const isHighlight = highlightWords.some((h) =>
          word.toLowerCase().includes(h.toLowerCase())
        );

        return (
          <span
            key={i}
            style={{
              display: "inline-block",
              opacity: p,
              transform: `translateY(${(1 - p) * 24}px)`,
              filter: `blur(${(1 - p) * 6}px)`,
              color: isHighlight ? highlightColor : "inherit",
            }}
          >
            {word}
          </span>
        );
      })}
    </div>
  );
};
